import styled from 'styled-components';

interface CellProps {
  width: string;
  border?: boolean;
  textAlign?: string;
}

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-top: 1px solid #616161;
  table-layout: fixed;
`;

const Row = styled.tr`
  width: 100%;
  border-bottom: 1px solid #e1e2e4;
`;

const TitleCell = styled.td<CellProps>`
  width: ${({ width }) => width};
  background-color: #f7f8fc;
  color: #616161;
  padding: 12px;
  text-align: center;
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  line-height: 145%;
`;

const ContentCell = styled.td<CellProps>`
  width: ${({ width }) => width};
  padding: 12px;
  text-align: ${({ textAlign }) => textAlign || 'left'};
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 500;
  overflow-wrap: break-word;
  break-word: break-all;
  color: #222;
  line-height: 145%;
  &:not(:last-child) {
    border-right: ${({ border }) => (border ? '1px solid #e8e9ea' : 'none')};
  }
`;
const TableHeadTh = styled.th<CellProps>`
  width: ${({ width }) => width};
  text-align: center;
  padding: 10px 0;
  background-color: #f7f8fc;
  font-size: 13px;
  font-weight: 500;
  line-height: 145%; /* 26.1px */
  letter-spacing: -0.36px;
  color: #616161;

  &:not(:last-child) {
    border-right: 1px solid #e8e9ea;
  }
`;
const GrayBox = styled.div`
  width: 100%;
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid #e1e2e4;
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-family: Spoqa Han Sans Neo;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 23.2px */
  letter-spacing: -0.32px;
  color: rgba(55, 56, 60, 0.61);
`;
const NoteTitle = styled.div`
  font-size: 13px;
  font-weight: 700;
  color: #616161;
`;

export const t = {
  Table,
  Row,
  TitleCell,
  ContentCell,
  TableHeadTh,
  GrayBox,
  NoteTitle,
};
